import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthSocketService {
  _socket: Socket;
  _emailSocket: Socket;
  _widgetSocket: Socket;

  get socket() {
    return this._socket;
  }

  get emailSocket() {
    return this._emailSocket;
  }

  get widgetSocket() {
    return this._widgetSocket;
  }

  constructor() {}

  connect() {
    if (this._socket) {
      return;
    }
    this._socket = io(environment.socketUrl, {
      auth: { token: localStorage.getItem('JWT_TOKEN'), admin: false },
    });
  }

  disconnect() {
    if (this._socket) {
      this._socket.disconnect();
      this._socket = null;
    }
  }

  connectEmailSocket(email: string) {
    this._emailSocket = io(`${environment.socketUrl}/spot`, {
      auth: { id: email },
    });
  }

  connectWidgetSocket(numberIdOrSignature: string) {
    this._widgetSocket = io(`${environment.socketUrl}/spot`, {
      auth: { id: numberIdOrSignature },
    });
  }

  disconnectEmailSocket() {
    if (this._emailSocket) {
      this._emailSocket.disconnect();
    }
  }

  disconnectWidget() {
    if (this._widgetSocket) {
      this._widgetSocket.disconnect();
      this._widgetSocket = null;
    }
  }
}
